import { render, staticRenderFns } from "./PurchaseOrderLockNotification.vue?vue&type=template&id=2762f274&scoped=true"
import script from "./PurchaseOrderLockNotification.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderLockNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2762f274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2762f274')) {
      api.createRecord('2762f274', component.options)
    } else {
      api.reload('2762f274', component.options)
    }
    module.hot.accept("./PurchaseOrderLockNotification.vue?vue&type=template&id=2762f274&scoped=true", function () {
      api.rerender('2762f274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/PurchaseOrderLockNotification.vue"
export default component.exports